import { Component, Input } from '@angular/core';

@Component({
  selector: 'tracking-page-marker',
  template: `
    <div [style.position]="'relative'">
      <svg
        style="position: absolute; top: 70px; left: 50px;"
        width="38"
        height="45"
        viewBox="0 0 38 45"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <ellipse opacity="0.2" cx="18.7691" cy="39.3594" rx="18.7691" ry="4.74373" [attr.fill]="colorHex" />
        <ellipse cx="18.7691" cy="39.3596" rx="1.7721" ry="0.834228" [attr.fill]="colorHex" />
        <mask
          id="path-3-outside-1_54_2765"
          maskUnits="userSpaceOnUse"
          x="2.67041"
          y="0"
          width="33"
          height="38"
          fill="black">
          <rect fill="white" x="2.67041" width="33" height="38" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M23.0934 29.8982C28.9361 28.1164 33.1865 22.6836 33.1865 16.2581C33.1865 8.38355 26.803 2 18.9285 2C11.054 2 4.67041 8.38355 4.67041 16.2581C4.67041 22.6757 8.91043 28.1031 14.742 29.8916C15.6648 30.4696 16.4394 31.2727 16.9854 32.2388L18.8538 35.5449C18.8865 35.6029 18.9701 35.6027 19.0027 35.5446L20.8359 32.2703C21.3828 31.2934 22.1628 30.4815 23.0934 29.8982Z" />
        </mask>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M23.0934 29.8982C28.9361 28.1164 33.1865 22.6836 33.1865 16.2581C33.1865 8.38355 26.803 2 18.9285 2C11.054 2 4.67041 8.38355 4.67041 16.2581C4.67041 22.6757 8.91043 28.1031 14.742 29.8916C15.6648 30.4696 16.4394 31.2727 16.9854 32.2388L18.8538 35.5449C18.8865 35.6029 18.9701 35.6027 19.0027 35.5446L20.8359 32.2703C21.3828 31.2934 22.1628 30.4815 23.0934 29.8982Z"
          [attr.fill]="colorHex" />
        <path
          d="M23.0934 29.8982L22.51 27.9852L22.2561 28.0626L22.0312 28.2036L23.0934 29.8982ZM14.742 29.8916L15.8037 28.1967L15.5804 28.0568L15.3284 27.9795L14.742 29.8916ZM16.9854 32.2388L18.7266 31.2548L16.9854 32.2388ZM18.8538 35.5449L20.595 34.5609L20.595 34.5609L18.8538 35.5449ZM19.0027 35.5446L17.2576 34.5675L17.2576 34.5675L19.0027 35.5446ZM20.8359 32.2703L19.0908 31.2933L20.8359 32.2703ZM31.1865 16.2581C31.1865 21.7793 27.5347 26.4529 22.51 27.9852L23.6768 31.8112C30.3374 29.78 35.1865 23.5879 35.1865 16.2581H31.1865ZM18.9285 4C25.6984 4 31.1865 9.48812 31.1865 16.2581H35.1865C35.1865 7.27898 27.9076 0 18.9285 0V4ZM6.67041 16.2581C6.67041 9.48812 12.1585 4 18.9285 4V0C9.94939 0 2.67041 7.27898 2.67041 16.2581H6.67041ZM15.3284 27.9795C10.3132 26.4414 6.67041 21.7725 6.67041 16.2581H2.67041C2.67041 23.5789 7.50762 29.7648 14.1555 31.8037L15.3284 27.9795ZM18.7266 31.2548C18.0152 29.996 17.0058 28.9497 15.8037 28.1967L13.6803 31.5865C14.3237 31.9896 14.8636 32.5494 15.2442 33.2228L18.7266 31.2548ZM20.595 34.5609L18.7266 31.2548L15.2442 33.2228L17.1126 36.5289L20.595 34.5609ZM17.2576 34.5675C17.9869 33.2649 19.8604 33.261 20.595 34.5609L17.1126 36.5289C17.9127 37.9447 19.9534 37.9405 20.7478 36.5216L17.2576 34.5675ZM19.0908 31.2933L17.2576 34.5675L20.7478 36.5216L22.581 33.2474L19.0908 31.2933ZM22.0312 28.2036C20.8193 28.9632 19.8032 30.0207 19.0908 31.2933L22.581 33.2474C22.9624 32.566 23.5064 31.9998 24.1556 31.5928L22.0312 28.2036Z"
          fill="#F7F7F7"
          mask="url(#path-3-outside-1_54_2765)" />
        <path
          d="M18.4443 9.35267L12.7122 14.1285C12.5395 14.2724 12.4397 14.4855 12.4397 14.7102V21.1704C12.4397 21.5885 12.7787 21.9275 13.1968 21.9275H16.0077C16.4259 21.9275 16.7648 21.5885 16.7648 21.1704V18.3583C16.7648 17.9402 17.1038 17.6013 17.5219 17.6013H20.335C20.7531 17.6013 21.0921 17.9402 21.0921 18.3583V21.1704C21.0921 21.5885 21.431 21.9275 21.8492 21.9275H24.6601C25.0782 21.9275 25.4172 21.5885 25.4172 21.1704V14.7101C25.4172 14.4855 25.3174 14.2724 25.1448 14.1285L19.4136 9.35271C19.1329 9.11877 18.7251 9.11875 18.4443 9.35267Z"
          fill="white" />
      </svg>
    </div>
  `,
  standalone: false,
})
export class TrackingPageMarker {
  @Input() colorHex: string;

  constructor() {}
}
